import { AxiosAdapter, CommonAdapter } from '@adapters';
import { FetchListByGroupCodeUseCase } from '@core/useCases';
import { computed, onMounted, ref } from 'vue';
import { FetchListByGroupCodeResponse } from '@core/dto';
type COMMON_CODE =
  | 'SEX_CODE'
  | 'MEMBER_DIV'
  | 'AREA_CODE'
  | 'BSN_CODE'
  | 'MEMBER_GRADE';
export const useCommon = (commonCode: COMMON_CODE[]) => {
  const axiosAdapter = new AxiosAdapter();
  const commonAdapter = new CommonAdapter(axiosAdapter);
  const fetchListByGroupCodeUseCase = new FetchListByGroupCodeUseCase(
    commonAdapter
  );
  const commonSexCodeList = ref<FetchListByGroupCodeResponse[] | []>([]);
  const commonMemberDivList = ref<FetchListByGroupCodeResponse[] | []>([]);
  const commonMemberGradeList = ref<FetchListByGroupCodeResponse[] | []>([]);
  const commonAreaCodeList = ref<FetchListByGroupCodeResponse[] | []>([]);
  const commonBsnCodeList = ref<FetchListByGroupCodeResponse[] | []>([]);

  const sexCodeName = computed(() => (args: string) => {
    return commonSexCodeList.value.find((f) => f.comCode === args)?.comName;
  });
  const memberDivName = computed(() => (args: string) => {
    return commonMemberDivList.value.find((f) => f.comCode === args)?.comName;
  });
  const memberGradeName = computed(() => (args: string) => {
    return commonMemberGradeList.value.find((f) => f.comCode === args)?.comName;
  });
  const areaName = computed(() => (args: string) => {
    return commonAreaCodeList.value.find((f) => f.comCode === args)?.comName;
  });
  const bsnCodeName = computed(() => (args: string) => {
    return commonBsnCodeList.value.find((f) => f.comCode === args)?.comName;
  });

  onMounted(async () => {
    if (commonCode.includes('SEX_CODE')) {
      commonSexCodeList.value = await fetchListByGroupCodeUseCase.execute({
        groupCode: 'SEX_CODE',
        useFlag: true,
      });
    }
    if (commonCode.includes('MEMBER_DIV')) {
      commonMemberDivList.value = await fetchListByGroupCodeUseCase.execute({
        groupCode: 'MEMBER_DIV',
        useFlag: true,
      });
    }
    if (commonCode.includes('MEMBER_GRADE')) {
      commonMemberGradeList.value = await fetchListByGroupCodeUseCase.execute({
        groupCode: 'MEMBER_GRADE',
        useFlag: true,
      });
    }
    if (commonCode.includes('AREA_CODE')) {
      commonAreaCodeList.value = await fetchListByGroupCodeUseCase.execute({
        groupCode: 'AREA_CODE',
        useFlag: true,
      });
    }
    if (commonCode.includes('BSN_CODE')) {
      commonBsnCodeList.value = await fetchListByGroupCodeUseCase.execute({
        groupCode: 'BSN_CODE',
        useFlag: true,
      });
    }
  });

  return {
    commonSexCodeList,
    commonMemberDivList,
    commonAreaCodeList,
    commonBsnCodeList,
    commonMemberGradeList,

    sexCodeName,
    memberDivName,
    areaName,
    bsnCodeName,
    memberGradeName,
  };
};
